import { Papa } from 'ngx-papaparse';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogAddRows } from './../../dilog/add-rows.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../../../shared.service';
import { ApiCallStatusService } from 'src/app/services/api-call-status.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { ViewChild } from '@angular/core';
import { Workbook } from 'exceljs';
import * as FileSaver from 'file-saver';
import notify from 'devextreme/ui/notify';

declare var $: any;




@Component({
  standalone: false,
    selector: 'app-cyl-dx-form',
    templateUrl: './cyl-dx-form.component.html',
    styleUrls: ['./cyl-dx-form.component.scss']
})
export class CylDxFormComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
    gridColumns: any[] = [];
    gridRows: any[] = [];
    requestForm: FormGroup;
    @Input() dataSource: any;
    @Output() optSelected: EventEmitter<any> = new EventEmitter();
    @Input() itemCatalogId: any;
    @Input() itemCatalogGroupId: any;
    @Input() focalId: any;
    @Input() itemTypeMasterId: any;
    @Input() companyBranchId: any;
    @ViewChild(DxDataGridComponent) grid!: DxDataGridComponent;
    @Input() acknowledgement: any;
    loadingIndicator: boolean;
    showGenerateBtn: boolean;
    isEdit: boolean;
    SPH_RANGE = [];
    CYL_RANGE = [];
    barCodeSph: any;
    barCodeCyl: any;
    rangeStockListPayload = [];
    toggleTypesOfValue;
    isCsv: boolean;
    actionSheetVisible: boolean;
    actionSheetTarget: any;
    sphError: boolean;
    cylError: boolean;
    stockIcon: boolean;
    inputType: boolean;
    totalQTY: number;
    totalToggle: boolean;
    loadingStockAvailable: boolean;
    availableStock: number;
    previousStock: boolean;
    currentStock: boolean;
    showPreviousStock: boolean;
    showCurrentStock: boolean;
    readonly: boolean;
    displayOnly: boolean;
    rangeLoading: boolean;
    loadingAllAvailableStock: boolean;
    hideClearBtn: boolean;
    isPreviousStockValueSetInput: boolean;
    constructor(
        private sharedService: SharedService,
        public dialog: MatDialog,
        private papa: Papa,
        private apiCallStatusSrvs: ApiCallStatusService
    ) {

    }
    isApiInProgress$ = this.apiCallStatusSrvs.isApiInProgress$;

    ngOnInit() {
        this.totalQTY = 0;
        this.availableStock = 0;
        // this.showGenerateBtn = false;
        this.barCodeCyl = [];
        this.barCodeSph = [];
       // this.displayOnly = false;
    }
    private normalizeCode(v: any): string {
        return (v ?? '').toString().trim();
    }
    private existingDetailLookup(): Map<string, any> {
        const m = new Map<string, any>();
        for (const d of (this.dataSource?.rangeStockListPayload || [])) {
            const key = `${Number(d.sph)}|${Number(d.cyl)}`;
            m.set(key, d);
        }
        return m;
    }
    private existingIdsByCode(): Map<string, { vendorItemCatalogId: number; vendorItemCatalogDetailId: number }> {
        const map = new Map<string, { vendorItemCatalogId: number; vendorItemCatalogDetailId: number }>();
        const sources = [
            ...(Array.isArray(this.dataSource?.vendorItemCatalogDetail) ? this.dataSource.vendorItemCatalogDetail : []),
            ...(Array.isArray(this.dataSource?.rangeStockListPayload) ? this.dataSource.rangeStockListPayload : [])
        ];
        for (const d of sources) {
            const code = (d?.vendorItemCode ?? d?.code ?? d?.barcode ?? d?.vendorBarCode ?? '').toString().trim();
            if (!code) continue;
            if (!map.has(code)) map.set(code, {
                vendorItemCatalogId: Number(d.vendorItemCatalogId || 0),
                vendorItemCatalogDetailId: Number(d.vendorItemCatalogDetailId || 0)
            });
        }
        return map;
    }
    private hasDuplicateInSnapshot(snapshotRows: any[]): string[] {
        const seen = new Map<string, number>();
        const dups: string[] = [];
        for (const row of snapshotRows || []) {
            for (const cyl of this.CYL_RANGE || []) {
                const val = this.normalizeCode(row[this.colField(cyl)]);
                if (!val) continue;
                const n = (seen.get(val) || 0) + 1;
                seen.set(val, n);
                if (n === 2) dups.push(val);
            }
        }
        return dups;
    }
    private buildColumns(): void {
        const base = [{
            caption: 'SPH / CYL',
            dataField: '__sphKey',
            allowEditing: false,
            fixed: true,
            width: 110,
            dataType: 'number' as const,
            format: { type: 'fixedPoint', precision: 2 },
            alignment: 'right'
        }];

        const cylCols = (this.CYL_RANGE || []).map((cyl: number) => {
            const field = this.colField(cyl);
            return {
                caption: Number(cyl).toFixed(2),
                dataField: field,
                dataType: 'string' as const,
                cssClass: 'cyl-col',
                alignment: 'right',
                // ðŸ”´ Duplicate blocker at EDIT time
                validationRules: [{
                    type: 'custom',
                    reevaluate: true,
                    ignoreEmptyValue: true,
                    message: 'Duplicate barcode. Each barcode must be unique.',
                    validationCallback: (p: any) => {
                        const val = this.normalizeCode(p.value);
                        if (!val) return true; // blanks allowed
                        // Count occurrences of val across ALL rows for THIS column
                        let hits = 0;
                        for (const r of this.gridRows || []) {
                            const v = this.normalizeCode(r[field]);
                            if (v === val) hits++;
                            if (hits > 1) break;
                        }
                        return hits <= 1;
                    }
                }]
            };
        });

        this.gridColumns = [...base, ...cylCols];
    }
    onSaving(e: any) {
        // Make a snapshot of current rows and apply pending changes
        const snapshot = (this.gridRows || []).map(r => ({ ...r }));

        for (const ch of (e.changes || [])) {
            if (ch.type === 'update') {
                const key = ch.key?.__sphKey ?? ch.key;
                const rowIndex = snapshot.findIndex(r => r.__sphKey === key);
                if (rowIndex >= 0) {
                    Object.keys(ch.data || {}).forEach(df => {
                        snapshot[rowIndex][df] = ch.data[df];
                    });
                }
            }
        }

        const dups = this.hasDuplicateInSnapshot(snapshot);
        if (dups.length) {
            e.cancel = true;
            notify({
                message: `Duplicate barcode${dups.length > 1 ? 's' : ''} detected: ${dups.slice(0, 3).join(', ')}${dups.length > 3 ? 'â€¦' : ''}. Please ensure all barcodes are unique.`,
                type: 'error',
                width: 420,
                displayTime: 4000
            });
        }
    }

    exportToCsv() {
        // Commit any cell still in edit so we see its value
        this.grid?.instance.saveEditData();
        this.grid?.instance.closeEditCell?.();

        if (!this.gridRows?.length) {
            notify({ message: 'No data to export', type: 'warning', displayTime: 2000 });
            return;
        }

        // Header
        const headers = ['SPH / CYL', ...(this.CYL_RANGE || []).map(c => Number(c).toFixed(2))];
        let csv = headers.join(',') + '\n';

        // Rows
        for (const sph of (this.SPH_RANGE || [])) {
            const row: any[] = [Number(sph).toFixed(2)];
            const match = this.gridRows.find(r => Number(r.__sphKey) === Number(sph));
            for (const cyl of (this.CYL_RANGE || [])) {
                const field = this.colField(cyl);
                row.push(match ? (match[field] ?? '') : '');
            }
            csv += row.join(',') + '\n';
        }

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        FileSaver.saveAs(blob, 'StockGrid.csv');
    }

    exportToExcel() {
        // Same reason as CSV â€” commit pending edit
        this.grid?.instance.saveEditData();
        this.grid?.instance.closeEditCell?.();

        if (!this.gridRows?.length) {
            notify({ message: 'No data to export', type: 'warning', displayTime: 2000 });
            return;
        }

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Stock Grid');

        const headers = ['SPH / CYL', ...(this.CYL_RANGE || []).map(c => Number(c).toFixed(2))];
        worksheet.addRow(headers);

        for (const sph of (this.SPH_RANGE || [])) {
            const row: any[] = [Number(sph).toFixed(2)];
            const match = this.gridRows.find(r => Number(r.__sphKey) === Number(sph));
            for (const cyl of (this.CYL_RANGE || [])) {
                const field = this.colField(cyl);
                row.push(match ? (match[field] ?? '') : '');
            }
            worksheet.addRow(row);
        }

        workbook.xlsx.writeBuffer().then((buffer: any) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            FileSaver.saveAs(blob, 'StockGrid.xlsx');
        });
    }


    // Make cells readOnly if you previously disabled inputs via setBarCodeRange()
    onEditorPreparing(e: any) {
        if (e.parentType !== 'dataRow') return;

        if (e.dataField === '__sphKey') {
            e.editorOptions.readOnly = true;  // row header locked
            return;
        }

        // Do NOT force readOnly on data cells here.
        // Let allowEditing on the column (and your flags) control it.
    }


    onCellClick(e: any) {
        // Start edit immediately when you click a data cell
        if (e.column?.dataField && e.column.dataField !== '__sphKey') {
            e.component.editCell(e.rowIndex, e.columnIndex);
        }
    }


    // Paint stock badges or background
    onCellPrepared(e: any) {
        if (e.rowType !== 'data') return;
        if (e.column?.dataField === '__sphKey') return;

        const cell = e.cellElement as HTMLElement;
        const cyl = this.parseColField(e.column.dataField);
        const sph = e.data.__sphKey;

        // Current stock label (optional quick visual)
        if (this.currentStock && Array.isArray(this.dataSource?.rangeStockListPayload)) {
            const hit = this.dataSource.rangeStockListPayload.find(x =>
                Number(x.sph) === Number(sph) && Number(x.cyl) === Number(cyl));
            if (hit?.vendorItemCode != null && hit.vendorItemCode !== '') {
                cell.setAttribute('title', `Current: ${hit.vendorItemCode}`);
            }
        }

        // Previous stock badge via popover already handled by your getAvailableStock()
    }

    onCellValueChanged(e: any) {
        if (!e || !e.column || e.column.dataField === '__sphKey') return;

        const cyl = this.parseColField(e.column.dataField);
        const sph = Number(e.data.__sphKey);
        const next = this.normalizeCode(e.value);

        // Reuse your existing mechanism to upsert this cell into payload
        const hiddenId = `${sph}_${cyl}`;
        this.getRangeValues(next, cyl, sph, hiddenId);
        this.totalQTY = (this.rangeStockListPayload || []).length;
    }


    ngAfterViewInit() {
        $(document).ready(() => {
            var element = null;
            $('table tr td input').focus((e) => {
               element =  e.target.parentNode.parentNode.parentNode;
               $(element).find('th').css('background-color', 'lightgreen');
            }).blur(() => {
               $(element).find('th').css('background-color', 'inherit');
            })
        })
    }
    // get readOnlyforGen () {
    //     if (this.showGenerateBtn) {
    //         return false;
    //     } else {
    //         return true;
    //     }
    // }

  
    readCSV(event: any) {
        const files: FileList = event?.target?.files;
        if (!files || !files.length) return;

        // Commit any pending editor so we don't lose the last edit
        try {
            this.grid?.instance.saveEditData();
            this.grid?.instance.closeEditCell?.();
        } catch { }

        const file = files.item(0)!;
        const reader = new FileReader();

        reader.onload = () => {
            // Strip BOM, normalize
            const raw = String(reader.result ?? '').replace(/^\uFEFF/, '');

            const parsed = this.papa.parse(raw, {
                skipEmptyLines: true,
                dynamicTyping: false, // keep barcodes as strings
                delimiter: ''         // auto-detect
            });

            const rows: any[][] = parsed.data as any[][];
            if (!rows?.length || rows[0].length < 2) {
                notify({ message: 'CSV is empty or malformed.', type: 'error', displayTime: 2500 });
                return;
            }

            // Header: ["SPH / CYL", 0.00, -0.25, ...]  â†’ derive CYL columns
            const header = rows[0].map(h => (h ?? '').toString().trim());
            const cylHeaders = header
                .slice(1)
                .map(h => Number(String(h).replace(/[^\d.\-]/g, ''))) // tolerate spaces/symbols
                .filter(n => !Number.isNaN(n));

            if (!cylHeaders.length) {
                notify({ message: 'No CYL columns found in CSV header.', type: 'error', displayTime: 2500 });
                return;
            }

            // Body â†’ grid rows + SPH list
            const newRows: any[] = [];
            const sphValues: number[] = [];

            for (const r of rows.slice(1)) {
                if (!r?.length) continue;

                const sph = Number(String(r[0]).replace(/[^\d.\-]/g, ''));
                if (Number.isNaN(sph)) continue;

                const rowObj: any = { __sphKey: sph };
                cylHeaders.forEach((cyl, idx) => {
                    const cell = (r[idx + 1] ?? '').toString().replace(/\r/g, '').trim();
                    rowObj[this.colField(cyl)] = cell; // keep as string (barcode)
                });

                newRows.push(rowObj);
                sphValues.push(sph);
            }

            if (!newRows.length) {
                notify({ message: 'No rows found in CSV.', type: 'error', displayTime: 2500 });
                return;
            }

            // Set ranges and datasource (preserve SPH order, de-dup)
            const seen = new Set<number>();
            const orderedSPH = sphValues.filter(v => (seen.has(v) ? false : (seen.add(v), true)));

            this.CYL_RANGE = cylHeaders;
            this.SPH_RANGE = orderedSPH;
            this.gridRows = newRows;

            // Rebuild grid columns + datasource (keep alignment/formatting)
            const columns = [
                {
                    dataField: '__sphKey',
                    caption: 'SPH / CYL',
                    allowEditing: false,
                    width: 110,
                    dataType: 'number' as const,
                    format: { type: 'fixedPoint', precision: 2 },
                    alignment: 'right' as const
                },
                ...this.CYL_RANGE.map(cyl => ({
                    dataField: this.colField(cyl),
                    caption: Number(cyl).toFixed(2),
                    dataType: 'string' as const,
                    cssClass: 'cyl-col',
                    alignment: 'right' as const
                })),
            ];

            if (this.grid?.instance) {
                this.grid.instance.option('columns', columns);
                this.grid.instance.option('dataSource', this.gridRows);
                this.grid.instance.refresh();
            } else {
                // fallback if instance not ready
                this.rebuildGrid();
            }

            // Remove duplicates that came from CSV
            const dups = this.hasDuplicateInSnapshot(this.gridRows);
            if (dups.length) {
                notify({
                    message: `CSV contains duplicate barcode${dups.length > 1 ? 's' : ''}: ${dups.slice(0, 6).join(', ')}${dups.length > 6 ? '...' : ''}. Later duplicates were cleared.`,
                    type: 'error',
                    width: 460,
                    displayTime: 4500
                });
                const seen = new Set<string>();
                for (const row of this.gridRows) {
                    for (const cyl of this.CYL_RANGE) {
                        const field = this.colField(cyl);
                        const code = this.normalizeCode(row[field]);
                        if (!code) continue;
                        if (seen.has(code)) {
                            row[field] = '';
                        } else {
                            seen.add(code);
                        }
                    }
                }
                // Push cleared cells into the grid UI
                try { this.grid?.instance?.option('dataSource', this.gridRows); this.grid?.instance?.refresh?.(); } catch {}
            }

            // Update payload + totals after cleanup
            this.syncDetailsFromGrid();
            this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');

            notify({ message: 'CSV loaded.', type: 'success', displayTime: 1500 });
        };

        reader.readAsText(file);

        // Let user pick the same file again
        if (event?.target) event.target.value = '';
    }




    getInitForm() {
        this.requestForm = new FormGroup({
            sections: new FormArray([])
        });
    }

    /**
     * @name ngOnChanges
     * @desc Fires when change in input properties are detected
     * @return void
     */
    ngOnChanges(changes: SimpleChanges) {
        this.getInitForm();
        if (Object.keys(changes.dataSource.currentValue).length > 0) {
            this.rangeStockListPayload = [];
            this.previousStock = false;
            this.inputType = changes.dataSource.currentValue.inputType;
            this.stockIcon = changes.dataSource.currentValue.stockIcon;
            this.totalToggle = changes.dataSource.currentValue.totalToggle;
            this.showCurrentStock = changes.dataSource.currentValue.showCurrentStock;
            this.showPreviousStock = changes.dataSource.currentValue.showPreviousStock;
            this.hideClearBtn = changes.dataSource.currentValue.hideClearBtn;
            this.showGenerateBtn = changes.dataSource.currentValue.generateBtn;
            this.isPreviousStockValueSetInput = changes.dataSource.currentValue.isPreviousStockValueSetInput;
           // this.previousStock = changes.dataSource.currentValue.previousStock;
            this.readonly = changes.dataSource.currentValue.readonly;
            this.displayOnly = changes.dataSource.currentValue.displayOnly;
            
            this.addSection(changes.dataSource.currentValue);
            if (!this.showGenerateBtn) {
                this.checkRange();
            }
            if (changes.dataSource.currentValue.isEdit) {
                this.isPreviousStockValueSetInput = false;
                if (changes.dataSource.currentValue.rangeStockListPayload) {
                     this.setInventoryFormData(changes.dataSource.currentValue.rangeStockListPayload);
                }
                this.isEdit = true;
            }
            if (changes.dataSource.currentValue.rangeOption) {
                const payload = {
                    itemCatalogGroupId: this.itemCatalogGroupId,
                    itemTypeMasterId: this.itemTypeMasterId,
                    focalId: this.focalId,
                    sphmin: (changes.dataSource.currentValue.barCodeData.sphmin || changes.dataSource.currentValue.barCodeData.sphmin == 0) ? changes.dataSource.currentValue.barCodeData.sphmin : 0,
                    sphmax: (changes.dataSource.currentValue.barCodeData.sphmax || changes.dataSource.currentValue.barCodeData.sphmax == 0)  ? changes.dataSource.currentValue.barCodeData.sphmax : 0,
                    cylmin: (changes.dataSource.currentValue.barCodeData.cylmin || changes.dataSource.currentValue.barCodeData.cylmin == 0)  ? changes.dataSource.currentValue.barCodeData.cylmin : 0,
                    cylmax: (changes.dataSource.currentValue.barCodeData.cylmax || changes.dataSource.currentValue.barCodeData.cylmax == 0) ? changes.dataSource.currentValue.barCodeData.cylmax : 0,
                    addmin: (changes.dataSource.currentValue.barCodeData.addmin || changes.dataSource.currentValue.barCodeData.addmin == 0)  ? changes.dataSource.currentValue.barCodeData.addmin : 0,
                    addmax: (changes.dataSource.currentValue.barCodeData.addmax || changes.dataSource.currentValue.barCodeData.addmax == 0) ? changes.dataSource.currentValue.barCodeData.addmax : 0,
                    cxmin:  (changes.dataSource.currentValue.barCodeData.cxmin || changes.dataSource.currentValue.barCodeData.cxmin == 0) ? changes.dataSource.currentValue.barCodeData.cxmin : 0,
                    cxmax:  (changes.dataSource.currentValue.barCodeData.cxmax || changes.dataSource.currentValue.barCodeData.cxmax == 0) ? changes.dataSource.currentValue.barCodeData.cxmax : 0,
                };
                // this.barCodeSph = this.sharedService.generateRange((changes.dataSource.currentValue.sphmin as string).replace('-',''),(changes.dataSource.currentValue.sphmax as string).replace('-',''), 0.25);
                // this.barCodeCyl = this.sharedService.generateRange((changes.dataSource.currentValue.cylmin as string).replace('-',''),(changes.dataSource.currentValue.cylmax as string).replace('-',''), 0.25);
                this.validateBarcodeRequestRange(payload);
            }
        }
    }

    /**
     * @name addSection
     * @param data
     * @returns void
     * @description create section array
     */
    addSection(data?: any): void {
        if (data) {
            if (data.active) {
                this.showGenerateBtn = data.generateBtn;
                this.isCsv = data.csv;
                this.sectionsArray.push(this.createSection(data));
            }
        }
    }

    /**
     * @name createSection
     * @param data
     * @return FormGroup
     * @description section controls
     */
    createSection(data?: any): FormGroup {
        return new FormGroup({
            condition: new FormControl(data ? data.condition : '', []),
            active: new FormControl(data ? data.active : false, []),
            childern: new FormArray(this.addChildern(data.childern)),
        });
    }


    /**
     * @name addChildern
     * @param data
     * @returns childern array
     */
    addChildern(data?: any) {
        const formArray = [];
        data.forEach(child => {
            formArray.push(this.createChild(child));
        });
        return formArray;
    }

    /**
     * @name createChild
     * @param child
     * @return  childer controls
     * @deprecated child formcontrols
     */
    createChild(child?): FormGroup {
        return new FormGroup({
            name: new FormControl(child ? child.name : '', []),
            min: new FormControl(child ? child.min : '', [Validators.required]),
            max: new FormControl(child ? child.max : '', [Validators.required]),
            // min: new FormControl(child ? (child.valueType ? child.min : child.min.toString().replace('-','')) : '', [Validators.required]),
            // max: new FormControl(child ? (child.valueType ? child.max : child.max.toString().replace('-','')) : '', [Validators.required]),
            valueType: new FormControl(child.valueType, [])
            // valueType: new FormControl(child.name === 'CYL' ? true : false, [])
        });
    }


    /**
     * @name getAvailableStock
     * @param {*} e
     * @param {*} sph
     * @param {*} cyl
     * @memberof CylFormComponent
     */
    getAvailableStock(e, sph: any, cyl: any) {
        this.availableStock = 0;
        this.loadingStockAvailable = true;
        let payload = {
            itemCatalogGroupId: this.itemCatalogGroupId,
            sph: sph,
            cylOrAdd: cyl
        };
        this.sharedService.getAvailableStock(payload)
            .then((response: any) => {
                if (response.data.completed) {
                    this.loadingStockAvailable = false;
                    this.availableStock = response.data.payload;
                    this.actionSheetTarget = '#img-' + e;
                    this.actionSheetVisible = true;
                } else {
                    this.loadingStockAvailable = false;
                    this.availableStock = 0;
                    console.error(response);
                }
            })
            .catch(error => {
                this.availableStock = 0;
                this.loadingStockAvailable = false;
                console.log(error);

            });

    }

   

    /**
   * @name validateBarcodeRequestRange
   * @param {number} itemCatalogGroupId
   * @param {number} itemTypeMasterId
   * @param {number} focalId
   * @param {number} sphmin
   * @param {number} sphmax
   * @param {number} cylmin
   * @param {number} cylmax
   * @param {*} payload
   * @returns
   * @memberof SharedService
   */
    validateBarcodeRequestRange(payload) {
       this.rangeLoading = true;
        this.sharedService.validateBarcodeRequestRange(payload)
            .then((response: any) => {
                if (response.data.completed && response.data.payload.length > 0) {
                    this.rangeLoading = false;
                    this.setBarCodeRange(response.data.payload);
                } else {
                    this.rangeLoading = false;
                    console.error(response);
                }
            })
            .catch(error => {
                this.rangeLoading = false;
                console.log(error);

            });

    }
    /**
     * @name sectionsArray
     * @returns section array controls
     */
    get sectionsArray() {
        return this.requestForm.get('sections') as FormArray;
    }

    /**
     * @name getChildern
     * @param form section item index
     * @returns childern array controls
     */
    getChildern(form) {
        return form.controls.childern.controls;
    }

  


    /**
     * @name clearField
     * @return void
     */
    clearField(): void {
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').setValue('');
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue('');
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('min').setValue('');
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').setValue('');
        // const child = (this.requestForm.get('sections') as FormArray).at(0).get('childern') as FormArray;
        // while (child.length !== 0) {
        //     child.removeAt(0);
        // }
        this.rangeStockListPayload = [];
        this.SPH_RANGE = [];
        this.CYL_RANGE = [];
    }
    get availableStockInHand() {
        return Math.floor(Math.random() * 500);
    }

    /**
     * @name addRows
     * @return number of rows
     * @description modal popup
     */
    addRows() {
        const dialogRef = this.dialog.open(DialogAddRows, {
            width: '250px',
            data: { label: 'CYL' }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result.rows) {
                for (let i = 0; i < parseInt(result.rows); i++) {
                    // this.createCxTypeDetail();
                    this.updatedMaxVal('increment');
                }
            }
        });
    }

    /**
     * @name incrementMaxVal
     * @returns updated max value
     */
    updatedMaxVal(label: string) {
        const val = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value;
        if (label === 'increment') {
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue(parseInt(val) + 1);
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').setValue(parseInt(val) + 1);
        }
        if (label === 'decrement') {
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue(parseInt(val) - 1);
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').setValue(parseInt(val) - 1);
        }
    }

    /**
     * @name removeIndex
     * @param index
     * @return void
     * @description removing row index
     */
    removeIndex(index) {
        // this.SPH_RANGE.splice(index, 1);
        // this.CYL_RANGE.splice(index, 1);
        // const item = (this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray;
        // item.removeAt(index);
        this.updatedMaxVal('decrement');
        // ((this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray).removeAt(index);
    }

    getRangeValues(val, cyl, sph, hiddenId?: any) {

        if (!val) {
            // if value empty then remove it from collection
            for (let i = 0; i < this.rangeStockListPayload.length; i++) {
                if (
                    this.rangeStockListPayload[i].cyl === cyl &&
                    this.rangeStockListPayload[i].sph === sph
                ) {
                    this.rangeStockListPayload.splice(i, 1);
                    break;
                }
            }
            this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
            return;
        }
        // check whether the value already exist then modify it
        if (this.rangeStockListPayload.some(o => o.cyl === cyl && o.sph === sph)) {
            for (let i = 0; i < this.rangeStockListPayload.length; i++) {
                if (
                    this.rangeStockListPayload[i].cyl === cyl &&
                    this.rangeStockListPayload[i].sph === sph
                ) {
                    this.rangeStockListPayload[i]['vendorItemCode'] = val;
                    this.rangeStockListPayload[i]['status'] = 'active';
                    break;
                }
            }
            this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
        } else {
            // else not found so push it
            const rangePairObj = {
                cx: null,
                cxtypeId: null,
                vendorItemCode: val,
                cc: null,
                add: null,
                axis: null,
                cyl: cyl,
                ct: null,
                et: null,
                tc: null,
                wt: null,
                sph: sph,
                vendorItemCatalogId: hiddenId,
               status: 'active'
                // qty: eval(val)
            };
            //this.totalQTY += val;
            this.rangeStockListPayload.push(rangePairObj);
            this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
        }

    }

    // overLapRange(sph_min: any, sph_max: any, cyl_min: any, cyl_max: any) {
    //     let tempSPH_RANGE = [];
    //     let tempCYL_RANGE = [];
    //     if (sph_min && sph_max) {
    //         if (sph_max < sph_min) {
    //             return this.sphError = true;
    //         } else {
    //             this.sphError = false;
    //             if ((sph_min && sph_max || sph_min === 0 && sph_max || sph_min === 0 && sph_max == 0 || sph_min && sph_max === 0)) {
    //                 tempSPH_RANGE = this.sharedService.generateRange(
    //                     sph_min,
    //                     sph_max,
    //                     0.25
    //                   );
    //             }
    //         }
    //     }
    //     if (cyl_max < cyl_min) {
    //         return this.cylError = true;
    //     } else {
    //         this.cylError = false;
    //          if ((cyl_min && cyl_max || cyl_min === 0 && cyl_max || cyl_min === 0 && cyl_max === 0 || cyl_min && cyl_max === 0)) {
    //             tempCYL_RANGE = this.sharedService.generateRange(
    //                     cyl_min,
    //                     cyl_max,
    //                     0.25
    //                   );
    //             if (this.check_number(cyl_min)) {
    //                 tempCYL_RANGE.reverse();
    //             }
    //         } 
    //     }
    //     console.log('tempSPH_RANGE', tempSPH_RANGE.length)
    //     console.log('tempCYL_RANGE', tempCYL_RANGE.length)
    //     console.log('this.SPH_RANGE', this.SPH_RANGE.length)
    //     console.log('this.CYL_RANGE', this.CYL_RANGE.length)
    //     this.SPH_RANGE.forEach((sph, sphIndex) => {
    //         this.CYL_RANGE.forEach((cyl, index) => {
    //             if (tempSPH_RANGE.includes(sph) && tempCYL_RANGE.includes(cyl)) {
    //                 $('table tr td #delete-' + sphIndex + '-' + index).addClass('fa fa-trash d-none');
    //             } else {
    //                 $('table tr td #delete-' + sphIndex + '-' + index).removeClass('d-none');
    //             }
    //             // dataSource.forEach(data => {
    //             //     if (data.sph == sph.toString() && data.cyl == cyl.toString()) {
    //             //         setTimeout(() => {
    //             //              $('table tr td #currentStock-' + sphIndex + '-' + index).text(data.vendorItemCode);
    //             //         }, 10);
    //             //     }
    //             // });
    //         });
    //     });
        
    // }
    checkRange() {
        this.SPH_RANGE = [];
        this.CYL_RANGE = [];
        const sph_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').value;
        const sph_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value;
        const sph_valueType = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('valueType').value;
        const cyl_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('min').value;
        const cyl_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').value;
        const cyl_valueType = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('valueType').value;
        if (parseFloat(sph_max) < parseFloat(sph_min)) {
            return this.sphError = true;
        } else {
            this.sphError = false;
            if ((sph_min && sph_max || sph_min === 0 && sph_max || sph_min === 0 && sph_max == 0 || sph_min && sph_max === 0)) {
                // if ((sph_min !== "" || sph_min == 0 ) && (sph_max !== "" || sph_max == 0) && sph_min !== null && sph_max !== null) {
                    this.SPH_RANGE = this.sharedService.generateRange(
                        parseFloat(sph_min),
                        parseFloat(sph_max),
                        0.25
                      );
                // this.SPH_RANGE = this.sharedService.generateRange(sph_valueType ? -sph_max : sph_min, sph_valueType ? -sph_min : sph_max, 0.25);
                if (this.check_number(parseFloat(sph_min))) {
                    this.SPH_RANGE.reverse();
                }
            } else {
                this.SPH_RANGE = null;
            }
        }
        if (parseFloat(cyl_max) < parseFloat(cyl_min)) {
            return this.cylError = true;
        } else {
            this.cylError = false;
             if ((cyl_min && cyl_max || cyl_min === 0 && cyl_max || cyl_min === 0 && cyl_max === 0 || cyl_min && cyl_max === 0)) {
                // if ((cyl_min !== "" || cyl_min == 0) && (cyl_max !== "" || cyl_max == 0) && cyl_min !== null && cyl_max !== null) {
                    this.CYL_RANGE = this.sharedService.generateRange(
                        parseFloat(cyl_min),
                        parseFloat(cyl_max),
                        0.25
                      );
                // (cyl_max < cyl_min) ? this.isCylInvalid = true : this.isCylInvalid = false;
                // this.CYL_RANGE = this.sharedService.generateRange(cyl_valueType ? -cyl_max : cyl_min, cyl_valueType ? -cyl_min : cyl_max, 0.25);
                if (this.check_number(parseFloat(cyl_min))) {
                    this.CYL_RANGE.reverse();
                }
            } else {
                this.CYL_RANGE = null;
            }
        }
        this._afterCheckRangeGridRefresh();
    }

      
  /**
   * @name check_number
   * @param num_value
   * @returns bool
   */
  check_number(num_value) {
    if (num_value >= 0) {
      return false;
    } else {
      return true;
    }
  }
    toggleStock(label: string) {
       switch (label) {
           case 'previous':
               this.previousStock = !this.previousStock;
               this.getAllAvailableStock(this.companyBranchId, this.itemCatalogGroupId, ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value > 0 ?  true : false);
               break;
            case 'current':
               this.currentStock = !this.currentStock;
               this.setCurrentStock(this.dataSource.rangeStockListPayload);
             break;
       }
    }
     /**
   * @name getAllAvailableStock
   * @param {number} companyBranchId
   * @param {number} itemCatalogGroupId
   * @param {number} isPositiveRange
   * @returns
   * @memberof SharedService
   */
  getAllAvailableStock(companyBranchId: number, itemCatalogGroupId: number, isPositiveRange: boolean) {
    this.loadingAllAvailableStock = true;
    this.sharedService.getAllAvailableStock(companyBranchId, itemCatalogGroupId, isPositiveRange)
        .then((response: any) => {
            if (response.data.completed) {
            this.checkRange();
            this.loadingAllAvailableStock = false;
            this.setAvailableStock(response.data.payload.availableStock);
            } else {
                this.loadingAllAvailableStock = false;
                console.error(response);
            }
        })
        .catch(error => {
            this.loadingAllAvailableStock = false;
            console.log(error);

        });

 }
  /**
     * @name setCurrentStock
     * @requires params SPH_RANGE or CYL_RANGE
     * @returns value
     */
    setAvailableStock(dataSource) {
        // if (this.SPH_RANGE && this.SPH_RANGE.length > 0 && this.CYL_RANGE && this.CYL_RANGE.length > 0) {
            dataSource.forEach(data => {
            this.SPH_RANGE.forEach((sph, sphIndex) => {
                this.CYL_RANGE.forEach((cyl, index) => {
                        if (data.sph == sph.toString() && data.cyl == cyl.toString()) {
                            setTimeout(() => {
                                if(this.isPreviousStockValueSetInput) {
                                    $('table tr td #input-' + sphIndex + '-' + index).val(data.availableStock);
                                    this.getRangeValues(data.availableStock, cyl, sph);
                                }
                                 $('table tr td #availableStock-' + sphIndex + '-' + index).text(data.availableStock);
                            }, 10);
                        } else {
                            $('table tr td #availableStock-' + sphIndex + '-' + index).text('');
                        }
                    });
                });
            });
        // } else {
        //     console.error('Line: 634-SPH AND CYL LENGHT 0');
        // }
       
    }
 /**
     * @name setCurrentStock
     * @requires params SPH_RANGE or CYL_RANGE
     * @returns value
     */
    setCurrentStock(dataSource) {
        if (this.SPH_RANGE && this.SPH_RANGE.length > 0 && this.CYL_RANGE && this.CYL_RANGE.length > 0) {
        dataSource.forEach(data => {
            this.SPH_RANGE.forEach((sph, sphIndex) => {
                this.CYL_RANGE.forEach((cyl, index) => {
                
                        if (data.sph == sph.toString() && data.cyl == cyl.toString()) {
                            setTimeout(() => {
                                $('table tr td #currentStock-' + sphIndex + '-' + index).text(data.vendorItemCode);
                            }, 10);
                        }
                    });
                });
        });
    } else {
        console.error('Line: 617-SPH AND CYL LENGHT 0')
    }
    }
    /**
     * @name setInventoryFormData
     * @requires params SPH_RANGE or CYL_RANGE
     * @returns value
     */
    setInventoryFormData(dataSource) {
        this.SPH_RANGE.forEach((sph, sphIndex) => {
            this.CYL_RANGE.forEach((cyl, index) => {
                dataSource.forEach(data => {
                    if (data.sph == sph.toString() && data.cyl == cyl.toString()) {
                        this.getRangeValues(data.vendorItemCode, cyl, sph, 'hidden-' + sphIndex + '-' + index);
                        setTimeout(() => {
                            $('table tr td #input-' + sphIndex + '-' + index).val(data.vendorItemCode);
                            $('table tr td #hidden-' + sphIndex + '-' + index).val(data.vendorItemCatalogId);
                            if (this.isEdit) {
                                this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
                            }
                        }, 10);
                    }
                });
            });
        });
    }
    /**
     * @name setInventoryFormData
     * @requires params SPH_RANGE or CYL_RANGE
     * @returns value
     */
    setBarCodeRange(dataSource) {
        // if (data.sph && data.cyl) {
            this.SPH_RANGE.forEach((sphValue, sphIndex) => {
                this.CYL_RANGE.forEach((cylValue, index) => {
                    dataSource.forEach(data => {
                    let s = sphValue.toString().replace('-','');
                    let c = cylValue.toString().replace('-', '');
                    let sp = data.sph.toFixed(2).replace('-','');
                    let cy = data.cyl.toFixed(2).replace('-','');
                    $('table tr td #input-' + sphIndex + '-' + index).attr('disabled', 'disabled');
                        if (sp == s && cy == c) {
                            setTimeout(() => {
                                     $('table tr td #input-' + sphIndex + '-' + index).removeAttr('disabled');
                            }, 10);
                        } 
                    });
                });
        // }
        
        });
    }
    /***
     * @name toggleGenerateBtn
     * @returns boolean;
     */
    toggleGenerateBtn() {
        if (((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).length > 0) {
            const sph_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').value;
            const sph_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value;
            const cyl_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('min').value;
            const cyl_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').value;
                if ((sph_min !== "" && sph_max !== "" && cyl_min !== "" && cyl_max !== "") && ((sph_min || sph_min == 0) && (sph_max || sph_max == 0) && (cyl_min || cyl_min == 0) && (cyl_max || cyl_max == 0))){
                    
                    if  (parseFloat(cyl_max) > parseFloat(cyl_min) && parseFloat(sph_max) > parseFloat(sph_min)) {
                        return true;
                   } else {
                    return false;
                   }
                }
           
           
            // if (
            //     (sph_min && sph_max && cyl_min && cyl_max) ||
            //     (sph_min === 0 && sph_max && cyl_min === 0 && cyl_max) ||
            //     (sph_min === 0 && sph_max && cyl_min && cyl_max) ||
            //     (cyl_min === 0 && cyl_max && sph_min && sph_max) || (sph_min === 0 && sph_max === 0 && cyl_min === 0 && cyl_max === 0) || (sph_min === 0 && sph_max === 0 && cyl_min && cyl_max === 0)) {
            //     return true;
            // } else {
            //     return false;
            // }
        }
    }

    fixVerticalTabindex(selector) {
        if (typeof selector == 'undefined') {
            selector = '.reset-tabindex';
        }
        let tabindex = 1;
        $(selector).each((i, tbl) => {
            $(tbl).find('tr').first().find('td').each((clmn, el) => {
                $(tbl).find('tr td:nth-child(' + (clmn + 1) + ') div input').each((j, input) => {
                    $(input).attr('placeholder', tabindex);
                    $(input).attr('tabindex', tabindex++);
                });
            });
        });
    }
  

    private syncDetailsFromGrid(): void {
        const lookup = this.existingDetailLookup();
        const byCode = this.existingIdsByCode();
        const out: any[] = [];

        for (const row of (this.gridRows || [])) {
            const sph = Number(row.__sphKey);
            for (const cyl of (this.CYL_RANGE || [])) {
                const field = this.colField(cyl);
                const code = (row[field] ?? '').toString().trim();
                if (code) {
                    const key = `${sph}|${Number(cyl)}`;
                    const ex = byCode.get(code) || lookup.get(key) || {};
                    out.push({
                        sph,
                        cyl: Number(cyl),
                        vendorItemCode: code,
                        vendorItemCatalogId: Number(ex.vendorItemCatalogId || 0),
                        vendorItemCatalogDetailId: Number(ex.vendorItemCatalogDetailId || 0),
                        status: 'active',
                        active: true,
                    });
                }
            }
        }

        this.rangeStockListPayload = out;
    }


      /**
     * @name saveStockRequest
     * @param {FormGroup} requestForm
     * @returns payload form cxtypedetail
     */

    saveStockRequest(requestForm: FormGroup) {
        this.loadingIndicator = true;

        // Commit last edit and rebuild payload
        this.grid?.instance.saveEditData();
        this.grid?.instance.closeEditCell?.();
        this.syncDetailsFromGrid();

        // Final duplicate guard (CSV/manual edge-cases)
        const snapshot = (this.gridRows || []).map(r => ({ ...r }));
        const dups = this.hasDuplicateInSnapshot(snapshot);
        if (dups.length) {
            notify({
                message: `Duplicate barcode${dups.length > 1 ? 's' : ''} found: ${dups.slice(0, 5).join(', ')}${dups.length > 5 ? 'â€¦' : ''}. Please remove duplicates before saving.`,
                type: 'error',
                width: 420,
                displayTime: 4000
            });
            this.loadingIndicator = false;
            return;
        }

        // Range min/max (as you had)
        const sph_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').value;
        const sph_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value;
        const cyl_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('min').value;
        const cyl_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').value;

        // Only active items should be sent; backend handles deletions
        const finalList = (this.rangeStockListPayload || []).filter(x => x && (x.vendorItemCode ?? '') !== '');

        const payload = {
            sphmin: sph_min,
            sphmax: sph_max,
            cylmin: cyl_min,
            cylmax: cyl_max,
            rangeStockListPayload: finalList,
            totalQTY: this.totalQTY
        };

        if (requestForm.invalid) {
            this.loadingIndicator = false;
            return;
        }

        // Emit up to parent (your parent already calls submitData($event))
        this.optSelected.emit(payload);
        setTimeout(() => { this.loadingIndicator = false; }, 300);
    }




    // Formats a CYL to a safe dataField (e.g., -1.25 -> "c_m1_25", 0.5 -> "c_0_5")
    private colField(cyl: number): string {
        const s = Number(cyl).toFixed(2).replace('-', 'm').replace('.', '_');
        return `c_${s}`;
    }

    // Reverse: get the numeric cyl back from a dataField name
    private parseColField(field: string): number {
        // field like "c_m1_25" or "c_0_50"
        const raw = field.slice(2).replace('m', '-').replace('_', '.');
        // handle second underscore in cases like m1_25 -> replace only first '_'
        const parts = raw.split('_');
        const num = Number(parts[0] + (parts[1] ? '.' + parts[1] : ''));
        return num;
    }

//     // Build DevExtreme columns dynamically from CYL_RANGE
//    private buildColumns(): void {
//   const base = [
//     {
//       caption: 'SPH / CYL',
//       dataField: '__sphKey',
//       allowEditing: false,
//       fixed: true,
//       width: 110,
//     }
//   ];

//   const cylCols = (this.CYL_RANGE || []).map((cyl) => {
//     const field = this.colField(cyl);
//     return {
//       caption: `${cyl}`,
//       dataField: field,
//       dataType: 'string' as const,             // <- editable text
//       allowEditing: !this.readonly && !this.acknowledgement
//       // â›”ï¸ no cellTemplate here
//     };
//   });

//   this.gridColumns = [...base, ...cylCols];
// }


    // Build rows from SPH_RANGE and preload any known codes
    // Uses your existing rangeStockListPayload to seed cell values
    private buildRows(): void {
        const rows: any[] = [];
        const lookup = new Map<string, string>(); // "sph|cyl" -> vendorItemCode

        const seed = this.rangeStockListPayload?.length
            ? this.rangeStockListPayload
            : (this.dataSource?.rangeStockListPayload || []);

        for (const it of (seed || [])) {
            lookup.set(`${Number(it.sph)}|${Number(it.cyl)}`, this.normalizeCode(it.vendorItemCode));
        }

        for (const sph of (this.SPH_RANGE || [])) {
            const row: any = { __sphKey: Number(sph) };
            for (const cyl of (this.CYL_RANGE || [])) {
                const key = `${Number(sph)}|${Number(cyl)}`;
                row[this.colField(cyl)] = lookup.get(key) ?? '';
            }
            rows.push(row);
        }

        this.gridRows = rows;
    }
    // Rebuild grid whenever ranges change or data is loaded
    private rebuildGrid(): void {
        this.buildColumns();
        this.buildRows();
        // totalQTY can be recalculated here if you want:
        this.totalQTY = (this.rangeStockListPayload || []).filter(x => this.normalizeCode(x.vendorItemCode)).length;
    }

    // Hook into your existing lifecycle:
    // 1) After Generate Range (checkRange), call rebuildGrid()
    private _orig_checkRange: any;



    private _afterCheckRangeGridRefresh(): void {
        if (this.SPH_RANGE?.length && this.CYL_RANGE?.length) {
            this.rebuildGrid(); // buildColumns + buildRows
            // Make absolutely sure edit payload reflects into the grid
            this.seedFromExistingPayload();

            if (this.currentStock && this.dataSource?.rangeStockListPayload) {
                this.setCurrentStock(this.dataSource.rangeStockListPayload);
            }
            if (this.previousStock) {
                this.getAllAvailableStock(
                    this.companyBranchId,
                    this.itemCatalogGroupId,
                    ((this.sectionsArray as any).at(0).get('childern') as any).at(0).get('max').value > 0
                );
            }
        } else {
            this.gridColumns = [];
            this.gridRows = [];
        }
    }
    // Ensure the grid displays existing values in edit mode using incoming payload
    private seedFromExistingPayload(): void {
        const seed = this.dataSource?.rangeStockListPayload || [];
        if (!this.gridRows?.length || !seed.length) return;

        const lookup = new Map<string, string>();
        for (const item of seed) {
            const sph = Number(item.sph);
            const cyl = Number(item.cyl);
            lookup.set(`${sph}|${cyl}`, item.vendorItemCode ?? '');
        }

        for (const row of this.gridRows) {
            const sph = Number(row.__sphKey);
            for (const cyl of this.CYL_RANGE || []) {
                const key = `${sph}|${Number(cyl)}`;
                const field = this.colField(cyl);
                const v = lookup.get(key);
                if (typeof v !== 'undefined') {
                    row[field] = v;
                }
            }
        }
        // Trigger change detection
        this.gridRows = [...this.gridRows];
    }
    /** Commit any pending cell edit and return the details derived from the grid */
    public async commitAndGetDetails(): Promise<any[]> {
        await this.grid?.instance.saveEditData();
        this.grid?.instance.closeEditCell();

        const lookup = this.existingDetailLookup();
        const details: any[] = [];
        if (!this.gridRows?.length || !this.CYL_RANGE?.length) return details;

        for (const row of this.gridRows) {
            const sph = Number(row.__sphKey);
            for (const cyl of this.CYL_RANGE) {
                const field = this.colField(cyl);
                const code = (row[field] ?? '').toString().trim();
                if (code !== '') {
                    const key = `${sph}|${Number(cyl)}`;
                    const ex = lookup.get(key) || {};
                    details.push({
                        sph,
                        cyl: Number(cyl),
                        vendorItemCode: code,
                        // carry ids when editing, otherwise 0 for new cells
                        vendorItemCatalogId: Number(ex.vendorItemCatalogId || 0),
                        vendorItemCatalogDetailId: Number(ex.vendorItemCatalogDetailId || 0),
                        active: true,
                    });
                }
            }
        }

        this.rangeStockListPayload = details;
        return details;
    }
    public getRangeSummary() {
        const sphArr = Array.isArray(this.SPH_RANGE) ? this.SPH_RANGE : [];
        const cylArr = Array.isArray(this.CYL_RANGE) ? this.CYL_RANGE : [];

        const sphmin = sphArr.length ? Math.min(...sphArr) : null;
        const sphmax = sphArr.length ? Math.max(...sphArr) : null;
        const cylmin = cylArr.length ? Math.min(...cylArr) : null;
        const cylmax = cylArr.length ? Math.max(...cylArr) : null;

        // If you keep ADD min/max in this component, expose them; otherwise null
        const addmin = (this as any).addmin ?? null;
        const addmax = (this as any).addmax ?? null;

        // If CX branch needs sections, expose them if present
        const sections = (this as any).sections ?? [];

        return { sphmin, sphmax, cylmin, cylmax, addmin, addmax, sections };
    }

    /**
     * @name destroy component
     */
    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        // this.subscription.unsubscribe();
    }
}
